import { useDispatch, useSelector } from "react-redux";
import { shouldRenderSpecField } from "../../../../../../redux/reducers/visibilityMatrixesReducer";
import { StoreType } from "../../../../../../redux/store/store";
import { updateSecondStepGeneralsNestedFields } from "../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../redux/reducers/claimFieldErrorsReducer";
import CountryAutocompleteField from "../../../../../../Components/CustomInputs/CountryAutocompleteField";

const ThroutfulPersonCitizenshipField = () => {
   const dispatch = useDispatch();
   const fieldNameLowerCase = "throutfulPersonCitizenship";
   const fieldNameUpperCase = "ThroutfulPersonCitizenship";
   const fieldValue = useSelector(
      (state: StoreType) =>
         state.claimState.personModel.personThroutful.throutfulPersonCitizenship
   );
   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );
   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );
   const isForeigner = useSelector(
      (state: StoreType) =>
         state.claimState.personModel.personThroutful.throutfulPersonIsForeigner
   );

   return (
      <CountryAutocompleteField
         labelText="Státní příslušnost (stát)"
         placeholderText="Uveďte stát vaší státní příslušnosti"
         value={fieldValue}
         validationText={handleShowErrorMessage(
            fieldNameUpperCase,
            claimFieldErrorsMessages
         )}
         dependencyValue={
            shouldRenderSpecField(
               "GeneralFields",
               fieldNameUpperCase,
               visibilityMatrixes
            ) && Boolean(isForeigner)
         }
         fieldNameForScroll={fieldNameUpperCase}
         onChange={(value) =>
            dispatch(
               updateSecondStepGeneralsNestedFields({
                  value,
                  sectionName: "personThroutful",
                  field: fieldNameLowerCase,
               })
            )
         }
      />
   );
};

export default ThroutfulPersonCitizenshipField;
